import { rgb } from "pdf-lib"

export function drawNewProductTableHeader(
  page,
  cursorY,
  labelValueSpacing,
  fontSize,
  font,
  tableHeaderX,
  vertical3LineX,
  labels
) {
  // Extract the label texts from the labels object
  const { priceNameHeaderLabel, priceUnitLabel, priceCountLabel, priceLabel, priceSumLabel } =
    labels

  // Draw the header texts at specified positions
  page.drawText(priceNameHeaderLabel, {
    x: vertical3LineX + 5,
    y: cursorY - labelValueSpacing,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0),
  })
  page.drawText(priceUnitLabel, {
    x: tableHeaderX * 10,
    y: cursorY - labelValueSpacing,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0),
  })
  page.drawText(priceCountLabel, {
    x: tableHeaderX * 11,
    y: cursorY - labelValueSpacing,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0),
  })
  page.drawText(priceLabel, {
    x: tableHeaderX * 12,
    y: cursorY - labelValueSpacing,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0),
  })
  page.drawText(priceSumLabel, {
    x: tableHeaderX * 13,
    y: cursorY - labelValueSpacing,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0),
  })
}
